var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about",staticStyle:{"margin-top":"100px"}},[_c('h1',[_vm._v("All Graduates Interpreting and Translating")])])}]

export { render, staticRenderFns }